"use client";
import Image from "next/image";
import {useState} from "react";
import {OutputResult} from "./leftWidgets/outputResult";
import {RoutesHistory} from "./rightWidgets/routeChangeHistory";
type TabList = "outputResult" | "history";
export const RoutesRightBar = function () {
  const [selectedTab, setSeleltedTab] = useState<TabList | null>(null);

  return (
    <>
      <div className="absolute right-1 top-0 z-10 h-[50%] w-10 rounded bg-white bg-opacity-90 p-2 shadow-md">
        <div className="flex flex-col items-center gap-4">
          <Image
            src={`/icons/routePlan/outputResult.svg`}
            alt={"Output Result"}
            onClick={() => setSeleltedTab("outputResult")}
            width={25}
            height={25}
            //className="mb-4"
          />
          <Image
            src={`/icons/routePlan/history.svg`}
            alt={"History"}
            onClick={() => setSeleltedTab("history")}
            width={25}
            height={25}
            //className="mb-4"
          />
        </div>
      </div>
      {selectedTab === "history" ? (
        <RoutesHistory />
      ) : selectedTab === "outputResult" ? (
        <OutputResult />
      ) : null}
    </>
  );
};
